import { WORKFLOW_STATUSES } from '../../services/workflow';
import type { AssessmentRow } from './AssessmentAdminPanel';

// Point/score/round columns are meaningless until QC has actually started.
export const beforeQc = (row: AssessmentRow): boolean => row.qcReviewStatus === 'initial_review';

// Survey status is the finalization record; qcReviewStatus lags it on rows finalized before the QC loop existed.
export const isFinalized = (row: AssessmentRow): boolean => ['Remediation', 'Complete', 'Completed'].indexOf(row.status) > -1;

const allIssuesApproved = (row: AssessmentRow): boolean => row.qcIssuesTotal > 0 && row.qcIssuesApproved === row.qcIssuesTotal;

// Reasons render as one-line menu hints, so they stay under ~30 characters.
export const finalizeBlockedReason = (row: AssessmentRow): string | undefined => {
  if (!row.workflowId) return 'No workflow';
  // Only unapproved QC issues block finalization — pre-QC-loop assessments raised none and pass freely.
  if (row.qcIssuesTotal > 0 && !allIssuesApproved(row)) {
    const remaining = row.qcIssuesTotal - row.qcIssuesApproved;
    return `${remaining} ${remaining === 1 ? 'issue' : 'issues'} not yet reviewed`;
  }
  return undefined;
};

export const continueReviewBlockedReason = (row: AssessmentRow): string | undefined => {
  if (isFinalized(row)) return 'Assessment finalized';
  if (beforeQc(row)) return 'After First Pass is submitted';
  return undefined;
};

export const qcRunEligibility = (row: AssessmentRow): { eligible: boolean; reason?: string } => {
  if (isFinalized(row)) return { eligible: false, reason: 'Already finalized' };
  if (row.qcFirstPassDone) return { eligible: false, reason: 'Already run' };
  const submitted = [row.workflowStatus, row.assessmentStatus, row.status].every(status => status === WORKFLOW_STATUSES.SUBMITTED);
  if (!submitted) return { eligible: false, reason: 'Awaiting submission' };
  if (!row.workflowId) return { eligible: false, reason: 'No workflow' };
  return { eligible: true };
};
